import { useParams, useSearchParams } from 'react-router-dom';
import { LiveCheckResult } from '../LiveCheckResult';
import { LIVE_CHECK } from '../mockData';
import { CHECK_HISTORY } from '../historyMock';
import { NotFoundInPage } from '@/components/NotFoundInPage';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import '../livecheck.css';

/** The ids that open a result: the report on file, today's checks and the full history. */
function isKnownCheck(id: string): boolean {
  return (
    id === LIVE_CHECK.report.checkId ||
    LIVE_CHECK.checkedToday.some((c) => c.id === id) ||
    CHECK_HISTORY.some((c) => c.id === id)
  );
}

export function LiveCheckResultPage() {
  usePageTopBar({});
  const { checkId = '' } = useParams();
  const [params] = useSearchParams();
  // ?state= and ?view= are review overrides on the fixture report; they skip the id check.
  const review = params.get('state') != null || params.get('view') != null;
  if (!review && !isKnownCheck(checkId)) {
    return (
      <div className="lc">
        <NotFoundInPage thing="check" id={checkId} listLabel="live checks" listTo="/live-check?tab=all" />
      </div>
    );
  }
  return <LiveCheckResult />;
}
